var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        { attrs: { title: "Users" } },
        [_c("v-icon", { on: { click: _vm.loadUsers } }, [_vm._v("refresh")])],
        1
      ),
      _vm._v(" "),
      _c("v-layout", { attrs: { column: "" } }, [
        _c(
          "div",
          { staticClass: "pt-3" },
          [
            _c(
              "v-card",
              [
                _c(
                  "v-card-title",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "", "align-end": "" } },
                      [
                        _c("v-flex", { attrs: { xs6: "" } }),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                "append-icon": "search",
                                label: "Search users",
                                "single-line": "",
                                "hide-details": ""
                              },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    "disable-initial-sort": "",
                    "must-sort": "",
                    items: _vm.users,
                    search: _vm.search,
                    "rows-per-page-items": [10, 20, 30]
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(slotItems) {
                        return [
                          _c(
                            "tr",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function($event) {
                                  slotItems.expanded = !slotItems.expanded
                                }
                              }
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(slotItems.item.id) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(slotItems.item.name) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(slotItems.item.contactEmail) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(slotItems.item.roles.join(",")) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  !_vm.hasAdminRole(slotItems.item)
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "accent" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleAdminRole(
                                                slotItems.item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Add LTN_ADMIN Role\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasAdminRole(slotItems.item)
                                    ? _c(
                                        "v-btn",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleAdminRole(
                                                slotItems.item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Remove LTN_ADMIN Role\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize",
                                      attrs: {
                                        flat: "",
                                        to: {
                                          name: "notification-settings",
                                          params: {
                                            authProviderId:
                                              slotItems.item.authProviderId
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Notifications Settings\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize",
                                      attrs: {
                                        flat: "",
                                        to: {
                                          name: "profile",
                                          params: { userId: slotItems.item.id }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Profile\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize",
                                      attrs: { flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.switchUser(slotItems.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Switch to this User\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-capitalize",
                                      attrs: { flat: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.sendPasswordEmail(
                                            slotItems.item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Send reset password email\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "expand",
                      fn: function(slotItems) {
                        return [
                          _c("user-expand", {
                            attrs: { "user-id": slotItems.item.id }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f296c7f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f296c7f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/UsersList.vue
// module id = null
// module chunks = 